<script>
import {Swiper, SwiperSlide} from 'vue-awesome-swiper'
import Translatable from '@src/mixins/translatable.js'

import 'swiper/css/swiper.css'

export default {
  components: {
    Swiper,
    SwiperSlide
  },
  mixins: [
    Translatable
  ],
  props: {
    object: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      swiperOptions: {
        allowTouchMove: true,
        navigation: {
          nextEl: '.right-tab-control',
          prevEl: '.left-tab-control'
        },
        pagination: {
          el: '.schedule-pagination',
          clickable: true,
          bulletClass: 'small-bullet',
          bulletActiveClass: 'small-bullet-active'
        },
      },
      childSize: 0,
      parentSize: 276,
      benefit: this.object.benefit,
      price: {
        adult: this.object.priceAdult,
        child: this.object.priceChild,
        adultWithCard: this.object.benefitAdult,
        childWithCard: this.object.benefitChild
      },
      contactInfo: {
        phone: this.object.phone,
        email: this.object.email,
        website: this.object.website,
        address: this.object.address1
      },
      transport: {
        metro: this.object.metro,
        tram: this.object.tram,
        bus: this.object.bus,
        funicular: this.object.funicular,
        ferry: this.object.ferry,
        parking: this.object.content.en.parking
      }
    }
  },
  computed: {
    availableTransport() {
      return Object.keys(this.transport).filter(transportType => {
        return this.transport[transportType] && this.transport[transportType] !== ''
      })
    },
    isSlider() {
      return this.childSize >= this.parentSize
    },
    isFreeEntry() {
      return this.object.typology === 'pc_free_entry'
    },
    benefitLabel() {
      return  this.isFreeEntry ? `${this.getTranslatedContent('ATTRACTIONS_label_free_entry') }`:
        this.object.typology === 'pc_free' || !this.object.typology ?
        `${this.getTranslatedContent('ATTRACTIONS_label_included')} ${this.getTranslatedContent('ATTRACTIONS_label_with_pass_card')}` :
        `${this.benefit} ${this.getTranslatedContent('ATTRACTIONS_label_with_pass_card')}`
    }
  },
  mounted() {
    this.childSize = document.querySelector('.items-container').offsetHeight;
  },
  methods: {
    transportLabel(transport) {
      return this.getTranslatedContent(`${transport.toUpperCase()}`)
    }
  },
}
</script>

<template>
  <div class="info-list">
    <Swiper :options="swiperOptions">
      <SwiperSlide>
        <div class="items-container">
          <div class="list-item">
            <i class="card"></i>
            <div class="card-benefit">
              <p class="benefit">{{ benefitLabel }}</p>
              <div class="price">
                <div class="price-container">
                  <p class="price-label">{{ getTranslatedContent('ATTRACTION_info_normal_price') }}</p>
                  <p class="price-value">{{ price.adult | KC }} / {{ price.child | KC }}</p>
                </div>
                <div v-if="!isFreeEntry" class="price-container">
                  <p class="price-label">{{ getTranslatedContent('ATTRACTION_info_withpass_price') }}</p>
                  <p class="price-value">{{ price.adultWithCard | KC }} / {{ price.childWithCard | KC }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="list-item contact-info">
            <i class="point"></i>
            <div class="address-data">
              <p class="address-line">{{ contactInfo.address }}</p>
              <p class="address-line">{{ contactInfo.phone }}</p>
              <a class="website" :href="contactInfo.website" target="_blank">{{ contactInfo.website }}</a>
              <a class="email" :href="`mailto:${contactInfo.email}`" target="_blank">{{ contactInfo.email }}</a>
            </div>
          </div>
          <div class="list-item" :class="!isSlider && availableTransport.length ? 'transport-info' : 'disabled'">
            <i class="metro-icon"></i>
            <div class="transport-data">
              <div
                v-for="(transportType, index) in availableTransport"
                :key="index"
                class="transport-row"
              >
                <p class="transport-type">{{ transportLabel(transportType) }}</p>
                <p class="transport-type-data">{{ transport[transportType] }}</p>
              </div>
            </div>
          </div>
        </div>
      </SwiperSlide>
      <SwiperSlide v-if="isSlider && availableTransport.length">
        <div class="list-item">
          <div class="items-container slide">
            <div class="list-item" :class="isSlider ? 'transport-info-slide' : 'transport-info'">
              <i class="metro-icon"></i>
              <div class="transport-data">
                <div
                  v-for="(transportType, index) in availableTransport"
                  :key="index"
                  class="transport-row"
                >
                  <p class="transport-type">{{ transportLabel(transportType) }}</p>
                  <p class="transport-type-data">{{ transport[transportType] }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </SwiperSlide>
      <div slot="button-prev" class="left-tab-control"></div>
      <div slot="button-next" class="right-tab-control"></div>
    </Swiper>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.info-list {
  width: 100%;
}

.list-item {
  display: flex;
  flex-direction: row;
  align-items: center;

  &.disabled {
    visibility: hidden;
  }

  & i {
    width: 43px;
    height: 43px;
  }

  & .card {
    background: url("../../assets/icons/carbon_ticket.svg") center no-repeat;
  }

  & .point {
    background: url("../../assets/icons/point.svg") center no-repeat;
  }

  & .metro-icon {
    background: url("../../assets/icons/underground.svg") center no-repeat;
    margin-left: 5px;
  }

  & .card-benefit {
    margin-left: 14px;
    display: flex;
    flex-direction: column;

    & .benefit {
      width: 185px;
      font-family: Open Sans Bold, sans-serif;
      font-style: normal;
      font-weight: bold;
      font-size: 14px;
      line-height: 18px;
      text-transform: uppercase;
      color: #FFFFFF;
    }

    & .price {
      margin-top: 5px;
      display: flex;
      flex-direction: column;

      .price-container {
        display: flex;
        flex-direction: row;
        justify-content: space-between;

        & .price-label {
          font-family: Open Sans, sans-serif;
          font-style: normal;
          font-weight: normal;
          font-size: 12px;
          line-height: 16px;
          text-transform: uppercase;
          color: #FFFFFF;
        }

        & .price-value {
          margin-left: 25px;
          font-family: Open Sans Semibold, sans-serif;
          font-weight: 600;
          font-style: normal;
          font-size: 12px;
          line-height: 16px;
          color: #FFFFFF;
        }

        & .price-value-with-coolpass {
          @extend .price-value;
          margin-top: 5px;
        }
      }
    }
  }

  & .address-data {
    width: 250px;
    margin-left: 14px;
    font-family: Open Sans Semibold, sans-serif;
    font-weight: 600;
    font-style: normal;
    font-size: 12px;
    line-height: 16px;
    text-transform: uppercase;
    color: #FFFFFF;

    :nth-child(1n) {
      margin-bottom: 5px;
    }

    & .website {
      text-decoration: none;
      color: inherit;
      word-break: break-word;

      &:hover {
        color: $orange;
      }
    }

    & .email {
      margin-top: 5px;
      text-decoration: none;
      color: inherit;
      display: block;

      &:hover {
        color: $orange;
      }
    }
  }

  &.transport-info, .transport-info-slide {
    margin-top: 30px;

    .transport-data {
      margin-left: 17px;
      width: 100%;

      .transport-row {
        display: flex;
        flex-direction: row;
        margin-bottom: 5px;

        .transport-type {
          font-family: Open Sans, sans-serif;
          font-style: normal;
          font-weight: bold;
          font-size: 12px;
          line-height: 16px;
          min-width: 56px;
          text-transform: uppercase;
          color: #FFFFFF;
          margin-right: 10px;
        }

        .transport-type-data {
          font-family: Open Sans, sans-serif;
          font-style: normal;
          font-weight: normal;
          font-size: 12px;
          line-height: 16px;
          text-transform: uppercase;
          color: #FFFFFF;
          // width: 100%;
          word-break: break-word;
        }
      }
    }
  }

  &.transport-info-slide {
    margin-top: 0;
  }
}

.contact-info {
  margin-top: 32px;
}

.items-container, .items-container-slide {
  width: 302px;
  margin: 30px auto;
}

.swiper-slide {
  height: 316px;
}

.control-mixin {
  position: absolute;
  width: 30px;
  height: 30px;
  top: 262px;
  cursor: pointer;
  z-index: 100;

  &.swiper-button-disabled {
    display: none;
  }
}

.left-tab-control {
  @extend .control-mixin;
  left: 23px;
  background: url("../../assets/icons/left.svg");
}

.right-tab-control {
  @extend .control-mixin;
  right: 23px;
  background: url("../../assets/icons/right.svg");
}

</style>
